import React from "react";
import PaymentMethods from "../../shared/components/PaymentMethods";

const SettingsPaymentMethodSection = ({ team, csrfToken, stripePublishableKey }) => {
  return (
    <PaymentMethods
      teamId={team.id}
      csrfToken={csrfToken}
      stripePublishableKey={stripePublishableKey}
      mode="manage"
    />
  );
};

export default SettingsPaymentMethodSection;
